module.exports = __webpack_public_path__ + "images/153_4096.jpg";